




















































import { Component, Vue } from 'vue-property-decorator';
import { MedTransGoConstants } from '../../util/constants';
import '../../assets/css/ServiceRequestDetails.scss';
import { ObjectFactory } from '@/config/objectFactory';
import { ApiRequest, FeedbackRequest} from '@/types/request';
import { CommonUtils } from '@/util/commonUtils';
import { Feedback } from '@/types/entity';
import MessageBox from '../../components/MessageBox.vue';
@Component({
    components: {
        MessageBox,
    },
    props: {
        id: String,
        request: Object,
    },
    data() {
        return {
            email: '',
            rating: '',
            comments: '',
            natureOfProblem: '',
            suggestion: '',
            problemOcurred: '',
            anySuggestions: '',
        };
    },
})
export default class ViewFeedbackModal extends Vue {
    private show = false;
    private showConfirmBox = false;
    private feedbacks: Feedback[] = [];
    public async mounted() {
        this.show = true;
        this.getRequestDetails();
    }

    private async getRequestDetails() {
        const response = await ObjectFactory.getRequestService().
        getRequestDetails(this.$props.request.id, this.$store.state.serverUrl);
    }

    private async updateFeedbackRequest(index?: number) {
        const serviceRequest = this.$props.request;
        const objIndex =  index ? index : 0;
        const feedbacks = serviceRequest.feedbacks[objIndex];
        const iHttpService = ObjectFactory.getHttpService();
        const feedback: FeedbackRequest = {
            requestId: this.$props.request.id,
            feedbackId: feedbacks.id,
            rating: this.$data.rating,
            comments: this.$data.comments,
            natureOfProblem: this.$data.natureOfProblem,
            suggestion: this.$data.suggestion,
        };
        const apiRequest: ApiRequest = {
            baseURL: this.$store.state.serverUrl,
            url: `${MedTransGoConstants.HTTP_URL_FEEDBACKS}/${feedbacks.id}/survey`,
            data: feedback,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<FeedbackRequest>(apiRequest);
        if (response) {
            const messageBox: any = this.$refs.messageBox;
            messageBox.showModal();
        } else {
            CommonUtils.showError(response);
            this.close();
        }
    }
    private close() {
        this.$emit('close');
    }
}
